import { useTranslate } from "@similarweb/i18n-provider";
import { OpenInNew } from "@similarweb/icons";
import { colorsPalettes } from "@similarweb/styles";
import { Button, Modal } from "@similarweb/ui-components";
import { Flex, Text } from "@similarweb/ui-components/foundations";

import { AssetsService } from "app/services/AssetsService";

import { EXTENSION_PROMO_IMAGE, MODAL_STYLES } from "./constants";
import { useSecondLandExtensionModal } from "./hooks/useSecondLandExtensionModal";
import { Card, CloseButton, Header, Illustration } from "./styles";
import { CTA, DESCRIPTION, TITLE } from "./texts";

export const SecondLandExtensionModal = () => {
    const { translate } = useTranslate();
    const { isOpen, handleClose, handleCtaClick } = useSecondLandExtensionModal();

    return (
        <Modal
            isOpen={isOpen}
            customStyles={{ content: MODAL_STYLES }}
        >
            <Card data-automation="second-land-extension-modal">
                <CloseButton
                    iconName="close"
                    type="flat"
                    iconSize="xs"
                    onClick={handleClose}
                    data-automation="second-land-extension-modal-close-button"
                />

                <Header>
                    <Text
                        fontVariant="h3"
                        color={colorsPalettes.carbon[500]}
                        textAlign="center"
                    >
                        {translate(TITLE)}
                    </Text>
                    <Text
                        fontVariant="body1"
                        color={colorsPalettes.carbon[400]}
                        textAlign="center"
                    >
                        {translate(DESCRIPTION)}
                    </Text>
                </Header>

                <Illustration
                    src={AssetsService.assetUrl(EXTENSION_PROMO_IMAGE)}
                    alt="extension promo"
                    data-automation="second-land-extension-modal-illustration"
                />

                <Button
                    type="primary"
                    onClick={handleCtaClick}
                    dataAutomation="second-land-extension-modal-cta"
                >
                    <Flex
                        inline
                        alignItems="center"
                        gap="8px"
                    >
                        <Text
                            fontVariant="button"
                            color={colorsPalettes.carbon[0]}
                            textAlign="center"
                        >
                            {translate(CTA)}
                        </Text>
                        <OpenInNew
                            size="xs"
                            color={colorsPalettes.carbon[0]}
                        />
                    </Flex>
                </Button>
            </Card>
        </Modal>
    );
};
